module.exports = __webpack_public_path__ + "static/media/centerBg.ca3212c5.png";